"use strict";

var identity = function identity(x) {
  return x;
};
var getUndefined = function getUndefined() {};
function createRavenMiddleware(Raven) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // TODO: Validate options.
  var _options$breadcrumbDa = options.breadcrumbDataFromAction,
      breadcrumbDataFromAction = _options$breadcrumbDa === undefined ? getUndefined : _options$breadcrumbDa,
      _options$actionTransf = options.actionTransformer,
      actionTransformer = _options$actionTransf === undefined ? identity : _options$actionTransf,
      _options$stateTransfo = options.stateTransformer,
      stateTransformer = _options$stateTransfo === undefined ? identity : _options$stateTransfo,
      _options$breadcrumbCa = options.breadcrumbCategory,
      breadcrumbCategory = _options$breadcrumbCa === undefined ? "redux-action" : _options$breadcrumbCa;

  Raven.setDataCallback(function (data, original) {
    data.extra.lastAction = actionTransformer(data.extra.lastAction);
    data.extra.state = stateTransformer(data.extra.state);
    return original ? original(data) : data;
  });
  return function (store) {
    // Record the initial state in case we crash before the first action
    // succeeds.
    // TODO: This does not currently work.
    Raven.setExtraContext({ state: store.getState() });

    return function (next) {
      return function (action) {
        // Log the action taken to Raven so that we have narrative context in our
        // error report.
        Raven.captureBreadcrumb({
          category: breadcrumbCategory,
          message: action.type,
          data: breadcrumbDataFromAction(action)
        });

        // Set the action as context in case we crash in the reducer.
        var extra = { lastAction: action };
        var returnValue = Raven.context({ extra: extra }, function () {
          return next(action);
        });

        // Set the last action and state as context in case we crash before
        // the next action is dispatched.
        Raven.setExtraContext({
          lastAction: action,
          state: store.getState()
        });
        return returnValue;
      };
    };
  };
}

module.exports = createRavenMiddleware;


//////////////////
// WEBPACK FOOTER
// ./~/raven-for-redux/built/index.js
// module id = 2134
// module chunks = 0